import { memo } from 'react';

import { ContentPopup } from './components';
import { ReportSchedulerContextProvider } from './ReportSchedulerPopup.context';
import { useReportSchedulerPopup } from './ReportSchedulerPopup.hooks';
import { ReportSchedulerPopupProps } from './ReportSchedulerPopup.types';

export const ReportSchedulerPopup = memo<ReportSchedulerPopupProps>((props) => {
    const { reportConfig } = props;

    const { isOpen, schedules, handleOpenToggle, handleSave } = useReportSchedulerPopup(reportConfig);

    if (!schedules) {
        return null;
    }

    return (
        <ReportSchedulerContextProvider data={schedules} onSave={handleSave}>
            <ContentPopup isOpen={isOpen} onToggle={handleOpenToggle} />
        </ReportSchedulerContextProvider>
    );
});

ReportSchedulerPopup.displayName = 'ReportSchedulerPopup';
